import { HandCash } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconHandCash12Line = createIcon(HandCash, 12, "Line");
export const IconHandCash16Line = createIcon(HandCash, 16, "Line");
export const IconHandCash20Line = createIcon(HandCash, 20, "Line");
export const IconHandCash24Line = createIcon(HandCash, 24, "Line");
export const IconHandCash32Line = createIcon(HandCash, 32, "Line");
export const IconHandCash48Line = createIcon(HandCash, 48, "Line");
export const IconHandCash64Line = createIcon(HandCash, 64, "Line");
